import { useEffect, useState } from 'react'
import './App.css'
import Footer from './Footer'
import Friend from './Friend'
import Self from './Self'
import Home from './Home'
import Header from './Header'

function App() {
    const [route, setRoute] = useState('home')

    useEffect(() => {
        window.scrollTo({
            top: 0,
        })
    }, [route])

    return (
        <>
            <Header route={route} onHandleRoute={(e) => setRoute(e)} />
            {route === 'home' && <Home onHandleRoute={(e) => setRoute(e)} />}
            {route === 'friend' && <Friend />}
            {route === 'self' && <Self />}
            <Footer />
        </>
    )
}

export default App
